var paragraph_default = {
  "fontElementMap": "T-IeQ",
  "elementSpacing": "RJWgX",
  "text": "SFG-K RJWgX",
  "child": "T1Eox"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
